module.exports = __webpack_public_path__ + "static/media/Share2.f63b3d05.svg";